<template>
    <div class="analysis">
        <div class="analysis-header">
            Analyse
        </div>
        <div class="markdown" v-html="renderedContent" </div>
        <button class="copy-button" @click="copyToClipboard" :title="copied ? 'Copié !' : 'Copier'">
            <span v-if="copied">✓</span>
            <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            >
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
            </svg>
        </button>
    </div>
</template>
<script>    
import { marked } from "marked";
export default{
    props:{
        message:Object
    },
    computed:{
        renderedContent(){
            return marked.parse(this.message.content);
        }
    },
    methods:{
        async copyToClipboard() {
            try {
                await navigator.clipboard.writeText(this.message.content);
                this.copied = true;
                setTimeout(() => {
                    this.copied = false;
                }, 2000);
            } catch (e) {
                console.error("Impossible de copier :", e);
            }
        }
    }
}
</script>

<style scoped>
.analysis{
    position: relative;
    background:#1b1d20;
    border:1px solid #2b2e33;
    border-radius:18px;
    padding:24px;
    margin-bottom:30px;
}

.analysis-header{
    color:#b91c1c;
    font-size:13px;
    font-weight:700;
    text-transform:uppercase;
    letter-spacing:.08em;
    margin-bottom:20px;
}

.markdown{
    color:#ececec;
    line-height:1.6;
}

.copy-button {
    position: absolute;
    right: 16px;
    top: 16px;
    width: 36px;
    height: 36px;
    border: none;
    border-radius: 10px;
    background: #2b2e33;
    color: white;
    cursor: pointer;
    transition: .2s;
}

.copy-button:hover {
    background: #b91c1c;
}
</style>